import { FC, useEffect, useRef, useState } from 'react';
import styles from './styles.module.scss';
import Checkbox from '@components/common/checkbox';
import { TColumn, TFilter, TSort } from '@components/table/index';
import { Icon } from '@components/icons';
import classNames from 'classnames/bind';
import { createPortal } from 'react-dom';
import useClickOutside from '@hooks/helpers/useClickOutside';

interface IProps {
    column: TColumn;
    handleFilterChange: (key: string, value: string, column: TColumn) => void;
    handleSortChange: (key: string) => void;
    sort?: TSort;
    filter?: TFilter;
    isActions?: boolean;
    isAllSelected?: boolean;
    onChangeAllSelected: () => void;
    selectKey?: string;
}

const cx = classNames.bind(styles);

const HeadItem: FC<IProps> = ({
    column,
    filter,
    sort,
    handleSortChange,
    handleFilterChange,
    isActions,
    selectKey,
    isAllSelected,
    onChangeAllSelected
}) => {
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const triggerRef = useRef(null);
    const dropdownRef = useRef(null);

    const showDropdown = () => {
        if (!dropdownRef.current) return;
        //@ts-ignore
        const triggerRect = triggerRef.current.getBoundingClientRect();

        // Calculate the position of the dropdown
        const top = triggerRect.bottom + window.scrollY;
        const left = triggerRect.left + window.scrollX;

        // Position the dropdown
        //@ts-ignore
        dropdownRef.current.style.top = `${top}px`;
        //@ts-ignore
        dropdownRef.current.style.position = `absolute`;
        //@ts-ignore
        dropdownRef.current.style.display = `flex`;
        //@ts-ignore
        dropdownRef.current.style.left = `${left - 100}px`;
        setIsFilterOpen(true);
    };

    const hideDropdown = () => {
        if (dropdownRef?.current) {
            //@ts-ignore
            const triggerRect = triggerRef.current.getBoundingClientRect();

            // Calculate the position of the dropdown
            const top = triggerRect.bottom + window.scrollY;
            const left = triggerRect.left + window.scrollX;
            //@ts-ignore
            dropdownRef.current.style.left = `${left - 100}px`;

            // Position the dropdown
            //@ts-ignore
            dropdownRef.current.style.top = `${top - 20}px`;
        }
        //@ts-ignore
        setIsFilterOpen(false);
    };

    useEffect(() => {
        if (dropdownRef?.current) {
            //@ts-ignore
            const triggerRect = triggerRef.current.getBoundingClientRect();

            // Calculate the position of the dropdown
            const top = triggerRect.bottom + window.scrollY;
            const left = triggerRect.left + window.scrollX;
            //@ts-ignore
            dropdownRef.current.style.left = `${left - 100}px`;

            // Position the dropdown
            //@ts-ignore
            dropdownRef.current.style.top = `${top - 20}px`;
        }
    }, [dropdownRef]);

    useClickOutside({
        ref: dropdownRef,
        callback: () => hideDropdown(),
        event: 'mousedown'
    });

    return (
        <th
            className={cx([
                { isSort: column.isSort, isActions: isActions || column.isRightAlignment }
            ])}>
            <div style={{ position: 'relative' }}>
                {selectKey && selectKey === column?.key && (
                    <div className={styles.select_wrapper}>
                        <Checkbox checked={isAllSelected} onClick={onChangeAllSelected} />
                    </div>
                )}
                <p>{column.label}</p>
                {column.isSort && (
                    <button
                        className={styles.filter_button}
                        onClick={() => handleSortChange(column.key || '')}>
                        <Icon
                            className={cx([
                                {
                                    isDesc: sort?.key === column.key && sort?.value === 'DESC'
                                }
                            ])}
                            name="nav_down"
                        />
                    </button>
                )}
                {column.filterOptions && (
                    <button
                        className={styles.filter_button}
                        ref={triggerRef}
                        onClick={() => (isFilterOpen ? hideDropdown() : showDropdown())}>
                        <Icon name="filter" />
                    </button>
                )}
                {column.filterOptions &&
                    createPortal(
                        <div
                            className={`table_filter_dropdown ${isFilterOpen ? 'isOpen' : ''}`}
                            style={{ position: 'absolute' }}
                            ref={dropdownRef}>
                            {column?.filterOptions?.map((option, i) => {
                                return (
                                    <label className="item" key={i}>
                                        <Checkbox
                                            onClick={() =>
                                                handleFilterChange(
                                                    column.key || '',
                                                    option.value,
                                                    column
                                                )
                                            }
                                            checked={filter?.[column?.key || '']?.includes(
                                                option.value
                                            )}
                                            variant="dark"
                                        />
                                        <p>{option.label}</p>
                                    </label>
                                );
                            })}
                        </div>,
                        document.body
                    )}
            </div>
        </th>
    );
};

export default HeadItem;
